<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="workbench-approval-main">
      <div class="top-title">当前审批进度</div>
      <div class="approval-result-box">
        <div style="width: 180px;display: flex;justify-content: space-between;">
          <div>
            <div style="font-size: 12px;color: #97A8BE;">提交人</div>
            <div>{{formData.personName}}</div>
            <div>{{formData.createTime}}</div>
          </div>
          <div style="border: 1px solid #D7D7D7;height: 28px;margin: 15px 0;"></div>
        </div>

        <!-- <div v-for="item in workData.contractApproveChainStatuses"> -->
          <!--审批通过-->
          <!-- <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '1' && item.approveResult === '1'">
            <div>
              <i class="iconfont el-icon-damai-shenpitongguo" style="color: #4FB07B;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #009933">审批通过</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveDate}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.memo || '无'}}</div>
            </div>
          </div> -->

          <!--审批中-->
          <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;">
            <div>
              <i class="iconfont el-icon-damai-shenpizhong" style="color: #F9A742;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #F9A742">{{formData.approveResult||'审批中'}}</div>
              <div style="font-size: 12px;color: #97A8BE;line-height: 40px;">{{formData.approveAccountName}}</div>
            </div>
          <!-- </div> -->

          <!--审批驳回-->
          <!-- <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 60px;" v-if="item.approveStatus === '1' && item.approveResult === '2'">
            <div>
              <i class="iconfont el-icon-damai-shenpibohui" style="color: #D81E06;font-size: 20px;"></i>
            </div>
            <div style="margin-left: 5px;">
              <div style="color: #D81E06">审批驳回</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveAccountName}}</div>
              <div style="font-size: 12px;color: #97A8BE;">{{item.approveDate}}</div>
              <div style="font-size: 12px;color: #97A8BE;width: 240px;">审批意见：{{item.memo || '无'}}</div>
            </div>
          </div>-->
        </div> 

      </div>

      <div class="top-title">审批详情</div>
      <div class="approval-detail-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="essentialInformation">
            <div class="form-title">人员信息</div>
            <div class="form-line">
              <div>
                <div class="line-text">姓名：</div>
                <div class="line-info">{{formData.personName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">手机号：</div>
                <div class="line-info">{{formData.personPhone || '无'}}</div>
              </div>
              <div>
                <div class="line-text">住户名称：</div>
                <div class="line-info">{{formData.enterpriseName || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">车牌号：</div>
                <div class="line-info">{{formData.carNumber || '无'}}</div>
              </div>
              <div>
                <div class="line-text">车位区域：</div>
                <div class="line-info">{{formData.parkingLotArea || '无'}}</div>
              </div>
              <div>
                <div class="line-text">车位号：</div>
                <div class="line-info">{{formData.parkingLotNumber || '无'}}</div>
              </div>
            </div>
            <div class="form-title">申请信息</div>
            <div class="form-line">
              <div>
                <div class="line-text">租赁开始时间：</div>
                <div class="line-info">{{formData.applyLeaseStartTime || '无'}}</div>
              </div>
              <div>
                <div class="line-text">有效期：</div>
                <div class="line-info">{{formData.applyLeaseValidityTime || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">类别：</div>
                <div class="line-info">{{formData.applyText || '无'}}</div>
              </div>
              <div>
                <div class="line-text">申请时间：</div>
                <div class="line-info">{{formData.createTime || '无'}}</div>
              </div>
            </div>
            <div class="form-line">
              <div>
                <div class="line-text">附件：</div>
                <img :src="annexUrl" alt="" class="annexImg" @click="largeImg(annexUrl)" v-if="annexUrl">
                <div v-else>无</div>
              </div>
            </div>
          </el-tab-pane>
          </el-tab-pane>
          <!-- <el-tab-pane label="账单信息" name="othersClause">
            <div style="height: 400px;overflow-y: auto;">
              <div class="form-title" style="border-left: 3px solid #ffffff;">账单信息</div>
              <div class="form-line" v-for="item in formData.otherPayItemDetails">
                <div>
                  <div class="line-text">账单开始时间：</div>
                  <div class="line-info">{{item.billStartTime || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">账单结束时间：</div>
                  <div class="line-info">{{item.billEndTime || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">金额：</div>
                  <div class="line-info" v-if="item.payMoney">{{item.payMoney}}元</div>
                  <div class="line-info" v-if="!item.payMoney">无</div>
                </div>
              </div>
            </div>
          </el-tab-pane> -->

          <!-- <el-tab-pane label="退租协议" name="rentRefundAgreement" v-if="formData.status === '6' ">
            <div style="height: 400px;overflow-y: auto;">
              <div class="form-title" style="border-left: 3px solid #ffffff;">退租信息</div>
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">退租原因：</div>
                  <div class="line-info">{{rentRefundAgreementData.surrenderReason || '无'}}</div>
                </div>
              </div>
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">备注：</div>
                  <div class="line-info">{{rentRefundAgreementData.memo || '无'}}</div>
                </div>
              </div>

              <div class="form-title" style="border-left: 3px solid #ffffff;">历史账单</div>
              <div v-if="historicalBillData.length === 0" style="padding-left: 10px;">暂无</div>
              <div v-if="historicalBillData.length > 0" style="margin-bottom: 20px;padding-left: 10px;">
                <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
                  <div style="width: 300px;">区间</div>
                  <div style="width: 150px;">费用类型</div>
                  <div style="width: 250px;">付款日</div>
                  <div style="width: 150px;">缴费状态</div>
                  <div style="width: 150px;">应缴金额(元)</div>
                </div>
                <div style="text-align: center;line-height: 36px;">
                  <div style="display: flex;justify-content: space-between;" v-for="item in historicalBillData">
                    <div style="width: 300px;">{{item.duration}}</div>
                    <div style="width: 150px;">{{item.feeType}}</div>
                    <div style="width: 250px;">{{item.payTime || '无'}}</div>
                    <div style="width: 150px;">{{item.payStatusText}}</div>
                    <div style="width: 150px;">{{item.payMoney || '0'}}元</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>


      <div class="operationBox">
        <!-- <button-cancel value="撤回" v-if="workType === 'sponsored' && workData.contractApproveChainStatuses[workData.contractApproveChainStatuses.length -1].approveStatus === '0'" @cancel="recallContract" /> -->
        <!-- <el-button size="small" class="btn-confirm"  @click="confirmApprove()">同意</el-button> -->
        <el-button size="small" class="btn-confirm"  @click="changeApprove()" v-if="formData.status=='0'">同意</el-button>
        <el-button size="small" class="reject-button"  @click="rejectApprove()" v-if="formData.status=='0'">驳回</el-button>
        <!--<button-cancel value="加签" v-if="workType === 'pendingApproval'" @cancel="submitAgainDialog = true" />-->
        <button-cancel value="返回" @cancel="toWorkbenchApprovalPage" />
      </div>
    </div>

    <!-- <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="approveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="memo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="passSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div> -->

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="approveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="rejectMemo" style="width: 300px;" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="unpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog
    title="调整"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">

      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">车位区域：</span>
        </div>
        <el-select v-model="formData.parkingLotArea"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择车位区域">
          <el-option v-for="item in parkingLotAreaList" :key="item.code"
                     :label="item.parkingLotAreaName" :value="item.code">
          </el-option>
        </el-select>
      </div> 

      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">车位号：</span>
        </div>
        <el-select v-model="formData.parkingLotNumber"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod2"
                   placeholder="请选择车位号">
          <el-option v-for="item in parkingLotList" :key="item.code"
                     :label="item.parkLotNumber" :value="item.code">
          </el-option>
        </el-select>              
      </div> 

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">起始日期：</span>
        </div>
          <el-date-picker v-model="formData.applyLeaseStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" size="small" @change="changeEnterStartDate()" style="width: 280px"></el-date-picker>
      </div>

            <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">选择缴费方式：</span>
        </div>
        <el-select  
          v-model="formData.paymentCycleText"
          filterable
          remote
          reserve-keyword
          placeholder="请选择缴费方式"
          size="small" style="width:280px"
          :remote-method="paymentRemoteMethod"
           >
           <el-option
            v-for="item in paymentList"
            :key="item.code"
            :label="item.paymentCycleName"
            :value="item.code"
            >
           </el-option>
        </el-select>
      </div>

    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmApprove">确 定</el-button>
    </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/WorkbenchApproval";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    ButtonConfirm,
    ButtonAdd,
    ButtonCancel,
    Breadcrumb
  },
  name: "other-approval-detail",
  data() {
    return {
      breadcrumb: [
        {
          value: "待办事项",
          name: "contract-approval"
        },
        {
          value: "审批详情"
        }
      ],
      approveDialog: false,
      approveRejectDialog: false,
      submitAgainDialog: false,
      workData: {},
      workType: "", // sponsored-我发起的  pendingApproval-待我审批  approved-我已审批
      activeName: "essentialInformation",
      accountCode: "",
      accountName: "",
      accountList: [],
      contractManagerLeaseItems: [],
      contractManagerPropertyItems: [],
      formData: {},
      memo: "",
      rejectMemo: "",
      approveAccountCode: "",
      additionalSignatureMemo: "",
      rentRefundAgreementData: {
        contractSurrenderDetails: [],
        surrenderReasonArr: []
      },
      historicalBillData: [],
      dialogVisible: false,
      areaCode: "",
      parkingLotAreaList: [],
      parkingLotList: [],
      paymentCode: "",
      paymentList: [],
      annexUrl: ""
    };
  },
  created() {
    // this.workData = this.$route.query.workData
    // this.workType = this.$route.query.workType
    this.workData = jQuery.parseJSON(sessionStorage.getItem("workDetailData"));
    this.workType = sessionStorage.getItem("workDetailActiveName");
    this.accountCode = bus.global.accountCode;
    this.accountName = bus.global.accountName;
    this.getContractByCode();
    this.remoteMethod();
    this.remoteMethod2();
    this.paymentRemoteMethod();
  },
  methods: {
    remoteMethod() {
      this.getParkingLotAreaList();
    },
    getParkingLotAreaList() {
      this.$axios
        .post(api.getParkingLotAreaList, {})
        .then(res => {
          this.parkingLotAreaList = res.data.data;
        })
        .catch(errorHandler("获取车位区域列表失败"));
    },
    remoteMethod2() {
      this.getParkingLotList();
    },
    getParkingLotList() {
      this.$axios
        .get(api.getParkingLotList + "/" + this.formData.parkingLotAreaCode, {})
        .then(res => {
          this.parkingLotList = res.data.data;
        })
        .catch(errorHandler("获取车位信息失败"));
    },
    // 跳转我的工作台
    toWorkbenchApprovalPage() {
      this.$router.back(-1);
    },
    // 获取合同信息
    getContractByCode() {
      this.$axios
        .get(`${api.getApplyByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data.applyType == "0") {
              data.applyText = "申请";
            } else if (data.applyType == "1") {
              data.applyText = "续租";
            }
            if (data.paymentCycle == "1") {
              data.paymentCycleText = "月缴";
            } else if (data.paymentCycle == "2") {
              data.paymentCycleText = "季缴";
            } else if (data.paymentCycle == "3") {
              data.paymentCycleText = "半年缴";
            } else if (data.paymentCycle == "4") {
              data.paymentCycleText = "年缴";
            }
            data.createTime = data.createTime.substring(0, 10);
            this.formData = data;
            this.annexUrl = data.annexUrl;
            this.remoteMethod2();
          }
        })
        .catch(errorHandler("查询失败"));
    },

    // 获取合同退租协议
    getSurrenderContractDetailByContractCode() {
      this.$axios
        .post(`${api.getSurrenderContractDetailByContractCode}`, {
          contractCode: this.workData.contractCode
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data) {
              this.rentRefundAgreementData = data;
            }
          }
        })
        .catch(errorHandler("查询合同退租协议失败"));
    },

    // 根据code查历史账单
    getListByContractCode() {
      this.$axios
        .post(api.getOtherPayItemDetailListByContractCode, {
          contractCode: this.workData.contractCode
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let rentHistoricalBillData = [];
            let propertyHistoricalBillData = [];
            data.map(v => {
              if (v.payStatus === "0") {
                v.payStatusText = "未缴费";
              } else if (v.payStatus === "1") {
                v.payStatusText = "已缴费";
              }
              if (v.feeType === "租金") {
                rentHistoricalBillData.push(v);
              } else if (v.feeType === "租金保证金") {
                this.rentDepositHistoricalBillData = v;
              } else if (v.feeType === "物业费") {
                propertyHistoricalBillData.push(v);
              } else if (v.feeType === "物业保证金") {
                this.propertyDepositHistoricalBillData = v;
              }
            });
            this.rentHistoricalBillData = rentHistoricalBillData;
            this.propertyHistoricalBillData = propertyHistoricalBillData;
            if (data) {
              this.historicalBillData = data;
            }
          }
        })
        .catch(errorHandler("查询历史账单失败"));
    },

    // 撤回审批
    recallContract() {
      this.$confirm("是否确认撤回审批？", "提示", {
        type: "info"
      })
        .then(() => {
          this.$axios
            .post(api.recallOtherContractApprove, {
              approveType: this.workData.approveType,
              contractCode: this.workData.contractCode
            })
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess("审批已撤回");
                this.toWorkbenchApprovalPage();
              }
            })
            .catch(errorHandler("审批撤回失败"));
        })
        .catch(() => {
          console.log();
        });
    },

    // 审批通过输入意见
    confirmApprove() {
      if (!this.formData.parkingLotAreaCode) {
        nError("请选择车位区域");
        return;
      }
      if (!this.formData.parkingLotCode) {
        nError("请选择车位号");
        return;
      }
      this.$axios
        .post(api.agreeApplyLease, this.formData)
        .then(res => {
          nSuccess("申请已通过");
          this.$router.back(-1);
        })
        .catch(errorHandler("审批失败"));
    },

    // 审批驳回输入意见
    rejectApprove() {
      this.approveRejectDialog = true;
    },

    // 取消审批通过
    cancelApprove() {
      this.memo = "";
      this.approveDialog = false;
    },

    // 审批通过
    // passSubmit() {
    //   this.$axios
    //     .post(api.passSubmitOtherContractManagerByCode, {
    //       code: this.workData.code,
    //       contractCode: this.workData.contractCode,
    //       memo: this.memo,
    //       contractApproveChainStatusCode: this.workData
    //         .contractApproveChainStatuses[0].code
    //     })
    //     .then(res => {
    //       if (res.data.retCode === 1) {
    //         nSuccess("审批已通过");
    //         this.memo = "";
    //         this.toWorkbenchApprovalPage();
    //       }
    //     })
    //     .catch(errorHandler("审批通过失败"));
    // },

    // 取消审批驳回
    cancelReject() {
      this.rejectMemo = "";
      this.approveRejectDialog = false;
    },

    // 审批驳回
    unpassSubmit() {
      this.$axios
        .post(api.rejectApplyLease, {
          code: this.formData.code,
          memo: this.rejectMemo
        })
        .then(res => {
          nSuccess("申请已拒绝");
          this.approveRejectDialog = false;
          this.$router.back(-1);
        })
        .catch(errorHandler("审批失败"));
    },

    changeApprove() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    changeEnterStartDate() {
      this.changePickerOptions1();
    },
    changePickerOptions1() {
      let leaseStartTime =
        new Date(this.formData.leaseStartTime).getTime() - 3600 * 24 * 1000;
      this.pickerOptions1 = {
        disabledDate(time) {
          return time.getTime() < leaseStartTime;
        }
      };
    },
    paymentRemoteMethod(query) {
      this.$axios
        .post(api.getParkingPaymentConfigList, {
          searchKey: query,
          configType: 4
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              if (v.paymentCycle === "1") {
                v.paymentCycleName = "月缴";
              } else if (v.paymentCycle === "2") {
                v.paymentCycleName = "季缴";
              } else if (v.paymentCycle === "3") {
                v.paymentCycleName = "半年缴";
              } else {
                v.paymentCycleName = "年缴";
              }
            });
            this.paymentList = data;
          }
        })
        .catch(errorHandler("获取缴费列表失败"));
    },
    largeImg(str) {
      var newwin = window.open();
      newwin.document.write("<img src=" + str + " />");
    }
  },
  watch: {
    "formData.parkingLotArea"(val) {
      this.parkingLotAreaList.map(v => {
        if (v.code == val) {
          this.formData.parkingLotArea = v.parkingLotAreaName;
          this.formData.parkingLotAreaCode = v.code;
          this.getParkingLotList();
        }
      });
    },
    "formData.parkingLotNumber"(val) {
      this.parkingLotList.map(v => {
        if (v.code == val) {
          console.log(v);
          this.formData.parkingLotNumber = v.parkLotNumber;
          this.formData.parkingLotCode = v.code;
        }
      });
    },
    "formData.paymentCycleText"(val) {
      this.paymentList.map(v => {
        if (v.code === val) {
          this.formData.paymentConfigCode = v.code;
          this.formData.paymentCycle = v.paymentCycle;
          this.formData.paymentMethod = v.paymentCycle;
          //   this.changeTime();
        }
      });
    }
  }
};
</script>

<style scoped>
.workbench-approval {
  text-align: left;
}
.workbench-approval-main {
  padding: 0 10px;
}
.top-title {
  color: #48576a;
  margin: 25px 0 10px 0;
  padding-left: 5px;
  font-size: 16px;
  line-height: 28px;
  border-left: 3px solid #00a0e6;
}
.approval-result-box {
  padding: 10px 30px;
  border-radius: 9px;
  color: #48576a;
  border: 1px solid #d7d7d7;
  display: flex;
  line-height: 20px;
  justify-content: flex-start;
}
.form-title {
  color: #666666;
  font-size: 14px;
  line-height: 24px;
  padding-left: 5px;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 130px;
  text-align: right;
}
.line-info {
  width: 215px;
}
</style>

<style lang="less">
.workbench-approval {
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      padding-left: 20px !important;
    }
    #tab-rentTerms {
      /*margin: 0 0 0 20px;*/
    }
    .is-top:last-child {
      padding-left: 0;
      .el-tabs__item {
        padding: 0 20px;
      }
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-detail-box {
    padding: 20px 10px;
    .el-tabs__content {
      padding-bottom: 20px;
    }
  }

  .btn-confirm {
    border: 0;
    color: #fff;
    padding: 8px 16px;
    background-color: #00a0e6;
    border-radius: 4px;
  }
  .btn-confirm:hover {
    color: #fff;
    background-color: #06b3ff;
  }

  .operationBox {
    display: flex;
    justify-content: flex-end;
    border-radius: 4px;
    .reject-button {
      background-color: #f25721;
      color: #ffffff;
    }
    .reject-button:hover {
      background-color: #f96e3d;
    }
  }
}

.approveDialogBox {
  text-align: left;
  .el-dialog {
    width: 800px;
  }
  .approveMainBox {
    text-align: center;
  }
  .approve_title {
    width: 120px;
  }
  .approveFlexBox {
    width: 500px;
    margin: 0 auto 20px;
    display: flex;
    justify-content: flex-start;
  }
  .red {
    color: red;
  }
}
</style>

<style lang="less" scoped>
.annexImg {
  width: 400px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/ParkingApplyDetail/ParkingApplyDetail.vue